import axiosInstance from '../components/utils/axios/axiosInstance';
import { SAVE_INPUT_VALUE, SAVE_GENERAL_SETTINGS } from './constantsActions';

export const getAllSettings = () => (dispatch) => {
  return new Promise((resolve, reject) => {
    axiosInstance
      .get('/api/settings/getAll', {
        params: {
          settingType: 'GENERAL'
        }
      })
      .then((res) => {
        dispatch({
          type: SAVE_GENERAL_SETTINGS,
          payload: res.data
        });
        resolve();
      })
      .catch(() => {
        reject();
      });
  });
};

export const setEmailRemainder = (inputValue, name) => {
  return {
    type: SAVE_INPUT_VALUE,
    payload: inputValue,
    inputName: name
  };
};

export const setAdminInputValue = (inputName, inputValue) => {
  return async (dispatch) => {
    await axiosInstance
      .post(
        '/api/settings/updateValue',
        {},
        {
          params: {
            name: inputName,
            value: inputValue
          }
        }
      )
      .then(() => {
        dispatch(setEmailRemainder(inputValue, inputName));
      })
      .catch(() => {});
  };
};

export function updateAdminRights(userId) {
  return {
    type: 'UPDATE_ADMIN_RIGHTS',
    id: userId
  };
}

export function addAdminRights(userId) {
  return {
    type: 'ADD_ADMIN_RIGHTS',
    id: userId
  };
}

export const giveAdminRights = (userId, hasAdminRole) => {
  return async (dispatch) => {
    await axiosInstance.post(
      'admin/user/toggleUserRole',
      {},
      {
        params: {
          id: userId,
          roleName: 'ROLE_ADMIN'
        }
      }
    );
    if (hasAdminRole) {
      dispatch(updateAdminRights(userId, hasAdminRole));
    } else {
      dispatch(addAdminRights(userId, hasAdminRole));
    }
  };
};
